<template>
    <div
        class="md-cta layout5 mg-bg"
        :class="{ 'mg-container': !fullColumn }"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            backgroundColor: bgColor
        }"
    >
        <div class="layout5-inner f-col">
            <div class="title" v-animated="{name: 'shift-right', enable: isMobile ? false: showAnimationEffects}">
                <site-title
                    :title="col1Title"
                    :size="34"
                    :mbSize="20"
                    :align="align"
                ></site-title>
                <site-sub-title
                    :title="col1SubTitle"
                    :size="16"
                    :mbSize="16"
                    :align="align"
                ></site-sub-title>
            </div>
            <div v-if="col1Buttons.length" class="btn-box">
                <banner-button
                    :buttons="col1Buttons"
                    @callback="showRegisterPop"
                ></banner-button>
            </div>
        </div>
    </div>
</template>

<script>
import common from '../index';
export default {
    mixins: [common],
    data: function() {
        return {
            title: '',
            subTitle: ''
        };
    }
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';
.md-cta.layout5 {
    .layout5-inner {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .btn-box {
            margin-left: 30px;
            .banner-button-v2 {
                .btn-item {
                    height: 50px;
                    line-height: 50px;
                    min-width: 200px;
                    margin: 0;
                    border: none;
                    font-size: 16px;
                    font-weight: 500;
                }
            }
        }
    }

    @include media-800 {
        .layout5-inner {
            flex-direction: column;

            .title {
                .site-title {
                    text-align: center
                }
            }
            .btn-box {
                margin-left: 0;
                margin-top: 30px;
            }
        }
    }
}
</style>
